module.exports = __webpack_public_path__ + "static/media/plant-icon.94e297de.svg";